import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import TickUrl from '@img/icons/tick.svg';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
import { FilterBreakpoint } from '../Filter/Filter.styles';
import { ThemeSwitch } from '@helpers/theme';
const Container = styled.section `
  position: relative;
  height: 100%;

  @media ${until(FilterBreakpoint)} {
    display: none;
  }
`;
const Inner = styled.div `
  align-items: center;
  z-index: 1;
  padding-right: 25px;
`;
const FilterTop = styled.div `
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 35px 0 15px;
  border-bottom: 1px solid ${brand.grey.grey89};
  margin-bottom: 10px;
`;
const Title = styled.span `
  ${fonts.DaxPro.Medium};
  font-size: 20px;
  margin: 0;
`;
const SelectedFilters = styled.div `
  flex: 1 0 100%;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const SelectedFilterBtn = styled.button `
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  ${ThemeSwitch({
    groundforceColour: rgba(brand.primary.base, 0.25),
    tpaColour: rgba(brand.tpa.base, 0.25),
})}
  background-color: var(--theme);
  border: none;
  border-radius: 100000px;
  padding: 6px 15px;

  svg {
    width: 10px;
    margin-left: 5px;
  }
`;
const ItemList = styled.div ``;
const Item = styled(m.div) `
  ${ButtonReset}
  display: block;
  width: 100%;
  text-align: left;
  ${ThemeSwitch({
    groundforceColour: rgba(brand.primary.base, 0.25),
    tpaColour: rgba(brand.tpa.base, 0.25),
})}
  background-color: var(--theme);
  margin-bottom: 2px;
`;
const ItemTitle = styled.button `
  ${fonts.DaxPro.Medium};
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 0;
  color: currentColor;
  margin: 0;
  padding: 15px;
  text-decoration: none;
  text-underline-position: under;
  width: 100%;
  cursor: pointer;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const ItemArrow = styled.span `
  display: block;
  margin-left: 20px;
  place-content: center;
  place-items: center;
`;
const ItemIcon = styled.span `
  display: block;
  flex: 0 0 auto;
  height: 16px;
  margin-left: auto;
  width: 16px;
  position: relative;

  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 16px;
    height: 2px;
    background-color: currentColor;
  }

  ${Item}[aria-expanded='true'] & {
    &::after {
      transform: translateY(-50%);
    }
  }

  &::before {
    transform: translateY(-50%);
  }

  &::after {
    transform: translateY(-50%) rotate(90deg);
  }
`;
const OptionOverlay = styled(m.div) `
  display: none;
  background-image: linear-gradient(to right, var(--bgColor), var(--bgColor));
  background-position: right;
  background-repeat: no-repeat;
  background-size: 50% 100%;
  color: var(--fgColor);
  overflow: hidden;
  width: 100%;
`;
const OptionList = styled.div `
  position: relative;
  z-index: 1;
  padding: 5px 15px;
`;
const Option = styled.div ``;
const OptionInput = styled.input `
  ${srOnly}
`;
const OptionLabel = styled.label `
  display: flex;
  color: currentColor;
  cursor: pointer;
  ${fonts.DaxPro.Regular};
  font-size: 18px;
  line-height: 30px;
  margin: 15px 0;
  ${ThemeSwitch({ groundforceColour: brand.primary.alt })}

  ${OptionInput}:disabled + & {
    opacity: 0.5;
  }

  &::before {
    content: '';
    display: block;
    background-color: ${brand.white};
    border: 1px solid ${brand.white};
    border-radius: 2px;
    box-sizing: border-box;
    color: ${brand.white};
    flex: 0 0 20px;
    font-size: 18px;
    height: 20px;
    line-height: 1em;
    margin-top: 5px;
    margin-right: 10px;
    padding-top: 2px;
    text-align: center;
    width: 20px;
    background-size: 75%;
    background-position: center;
    background-repeat: no-repeat;

    ${OptionInput}:checked + & {
      background-color: var(--theme);
      background-image: url(${TickUrl});
    }
  }
`;
const ResetButton = styled.button `
  display: inline-flex;
  align-items: center;
  background: none;
  border: 0;
  color: currentColor;
  cursor: pointer;
  ${fonts.DaxPro.Regular};
  font-size: 14px;
  line-height: 28px;
  margin: 0;
  padding: 0;
  text-decoration: underline;
  text-underline-position: under;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const FilterDesktopStyles = {
    Container,
    FilterTop,
    Inner,
    Item,
    ItemArrow,
    ItemIcon,
    ItemList,
    ItemTitle,
    Option,
    OptionInput,
    OptionLabel,
    OptionList,
    OptionOverlay,
    ResetButton,
    SelectedFilterBtn,
    SelectedFilters,
    Title,
};
export default FilterDesktopStyles;
